<template src="./Category.html"></template>
<style lang="scss" scoped src="./Category.scss"></style>

<script>

import Api from "@/api/Api";
import {OrkLoader, OrkProductCart} from "@/components/Ork";
import {
  SfSidebar,
  SfScrollable,
  SfRange,
  SfRadio,
  SfCheckbox,
  SfNotification,
  SfPagination,
  SfBreadcrumbs,
  SfDivider,
  SfHeading,
  SfSelect,
  SfButton,
  SfImage,
  SfIcon,
  SfFilter,
  SfLink,
  SfAccordion,
  SfBar
} from '@storefront-ui/vue';
import ProductOptions from "@/utils/product_options";
import {LightProduct} from "@/models/product";
import {Pagination} from "@/models/pagination";
import icons from "@/utils/icons";

export default {
  name: 'Category',
  components: {
    SfSidebar,
    SfBar,
    SfScrollable,
    SfLink,
    SfRadio,
    SfAccordion,
    SfRange,
    SfFilter,
    OrkProductCart,
    SfHeading,
    SfBreadcrumbs,
    SfNotification,
    SfPagination,
    SfButton,
    SfImage,
    SfCheckbox,
    SfIcon,
    SfSelect,
    OrkLoader,
    SfDivider
  },

  data() {
    return {
      hasInfiniteScroll: false,
      hasAutoLoad: false,
      scrollPosition: null,
      products: null,
      isShow: false,
      loading: false,
      loadingNext: false,
      error: null,
      pagination: Pagination.of(null),
      sortBy: {options: ProductOptions.getProductOptions.sortAttributes, selected: process.env.VUE_APP_DEFAULT_SORT},
      sortOption: ProductOptions.getProductOptions.sortAttributes,
      currentPage: this.$router.history.current.query.page || 1,
      totalPages: null,
      breadcrumbs: [],
      icons: icons,
      childrenCategory: [],
      marketing: null,
      marketingHeader: null,
      marketingDeo: null,
      loadingMarketing: false
    };
  },

  computed: {
    customer() {
      return this.$store.getters.getProfile;
    },
    categoryTree: {
      get() {
        return this.$store.getters.getCategoryTree
      }
    },
    activeCategory: {
      get() {
        const activeCategory = this.$store.getters.activeCategory(this.$route.params.level3 || this.$route.params.level2 || this.$route.params.level1);
        if (activeCategory) {
          return activeCategory
        }
        this.$router.push(this.$localizePath('/')).catch(() => {
        })
      },
      set(value) {
        if (!value) {
          this.$router.push(this.$localizePath('/404')).catch(() => {
          })
        }
      }
    },

  },
  created() {
    this.hasAutoLoad = eval(process.env.VUE_APP_CATEGORIES_AUTOLOAD);
    this.hasInfiniteScroll = eval(process.env.VUE_APP_CATEGORIES_INFINITESCROLL);
    this.checkActiveCategory(this.activeCategory);
    if (this.activeCategory) {
      /*if (this.$router.history.current.query.filters) {
        this.removeFilters(true)
      }*/
      this.setBreadcrumbs(this.$route.params);
      this.getCategoryMarketing(this.activeCategory)
      if (this.$router.history.current.query.page) {

        this.reloadProduct(this.activeCategory)
      } else {

        this.fetchProducts(this.activeCategory);
      }

    }
  },

  watch: {
    categoryTree: {
      handler(catNew, oldCat) {
        if (catNew && oldCat && catNew !== oldCat) {

          this.activeCategory = this.$store.getters.activeCategory(this.$route.params.level3 || this.$route.params.level2 || this.$route.params.level1)
          // this.routeChange()
          // this.getCategoryMarketing()
        }
        if (!oldCat) {
          this.activeCategory = this.$store.getters.activeCategory(this.$route.params.level3 || this.$route.params.level2 || this.$route.params.level1)
          // this.getCategoryMarketing()
        }

      }, immediate: true
    },
    activeCategory: {
      handler(newCat, oldCat) {

        if (this.categoryTree && this.categoryTree.children) {

          if (oldCat) {
            if (newCat) {
              if (newCat.path !== oldCat.path) {

                this.products = [];
                this.currentPage = 1;
                this.currentQuery = null
                if (!this.$router.history.current.query.sort) {
                  this.sortBy.selected = process.env.VUE_APP_DEFAULT_SORT
                }
              }
              this.setBreadcrumbs(this.$route.params)
              this.getCategoryMarketing();
              this.fetchProducts(this.activeCategory);


            }
          } else {
            if (newCat && newCat.path) {
              this.products = [];
              this.currentPage = 1;
              this.$store.dispatch('setPage', 1)
              // remove filter on relaod
              /* if (this.$router.history.current.query.filters) {
                this.removeFilters(true)
              }*/
              if (!this.$router.history.current.query.sort) {
                this.sortBy.selected = process.env.VUE_APP_DEFAULT_SORT
              }
              this.setBreadcrumbs(this.$route.params)
              this.getCategoryMarketing();
              this.fetchProducts(this.activeCategory);

            } else {
              this.$router.push(this.$localizePath('/404'))
            }
          }
        }
      }, immediate: false
    },
  },
  mounted() {
    //   this.$set('activeCategory',  this.$store.getters.activeCategory(this.$route.params.level3 || this.$route.params.level2 || this.$route.params.level1))
    window.addEventListener('scroll', this.updateScroll);
    if (this.hasInfiniteScroll && this.hasAutoLoad) {
      window.onscroll = () => {
        let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;
        if (bottomOfWindow) {
          this.loadNextProduct()
        }
      };
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.updateScroll);
  },
  methods: {

    showMore(){
      const desc = document.getElementById("descMarketingHeader")
      if(desc.classList.contains('show')){
        document.getElementById("descMarketingHeader").classList.remove('show')
        this.isShow = false;
      } else {
        document.getElementById("descMarketingHeader").classList.add('show')
        this.isShow = true
      }
    },
    loadNextProduct() {
      const query = {...this.$router.history.current.query}
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        query.page = this.currentPage
        this.$router.replace({query: {...query}})
      }
    },
    updateScroll() {
      this.scrollPosition = window.scrollY;
      if (this.scrollPosition > 30) {
        document.body.classList.add("notTop");
      } else {
        document.body.classList.remove("notTop");
      }
    },
    changeCategory() {
      this.getCategoryMarketing(this.activeCategory)
    },
    checkActiveCategory(activeCategory){

      if(activeCategory===undefined){
        this.$router.push('/404')
      }
    },

    getCategoryMarketing() {
      const categorySlug = this.$route.params.level1;
      const activeCategory = this.activeCategory;
      if (activeCategory) {

        this.marketing = null
        const descEl = document.querySelector('head meta[name="description"]');
        const titleEl = document.querySelector('head title');
        this.loadingMarketing = true;
        Api.marketing.getCategory(activeCategory.path)
            .then(data => {
              this.marketingHeader = data.header ? data.header : null;
              this.marketingSEO = data.seo ? data.seo : null
            }).catch((e) => {
          this.marketingHeader = {
            title: activeCategory.label,
            categorySlug,
          };
          console.log('marketing error',e);
        }).finally(() => {
          if (this.marketingSEO) {
            descEl.setAttribute('content', this.marketingSEO.description);
            titleEl.textContent = this.marketingSEO.title;
          } else {
            descEl.setAttribute('content', this.$i18n.t('seo.categoryDescription', {categoryName: activeCategory.label}));
            titleEl.textContent = activeCategory.label + ' | @SEO_DEFAULT_TITLE@';
          }
          this.loadingMarketing = false;
        })
      }
    },
    getChildCategory(activeCategory) {
      if (activeCategory && activeCategory.children && activeCategory.children.length > 0) {
        let children = [...activeCategory.children]
        this.childrenCategory = children.sort(function (a, b) {
              return a.label.localeCompare(b.label)
            }
        )

      } else {
        this.childrenCategory = [];
      }
    },
    setBreadcrumbs(params) {
      let breadcrumbs = [{
        text: this.$t('Home'),
        link: '/'
      },{
        text: this.$t('Category'),

      }];
      let level1 = null,
          level2 = null,
          level3 = null;

      if (params.level1) {
        const catlevel1 = this.categoryTree.children.find(categ => categ.slug === params.level1)
        if (catlevel1) {
          level1 = {text: catlevel1.label, link: '/categorie/' + catlevel1.slug}
          breadcrumbs.push(level1)
        }
        if (params.level2) {
          const catlevel2 = this.categoryTree.children.find(categ => categ.slug === params.level1).children.find(categlvl2 => categlvl2.slug === params.level2)
          if (catlevel2 && level1) {
            level2 = {text: catlevel2.label, link: level1.link + '/' + catlevel2.slug}
            breadcrumbs.push(level2)
          }
        }
        if (params.level3) {
          const catlevel3 = this.categoryTree.children.find(categ => categ.slug === params.level1).children.find(categlvl2 => categlvl2.slug === params.level2).children.find(categlvl3 => categlvl3.slug === params.level3)
          if (catlevel3 && level2) {
            level3 = {text: catlevel3.label, link: level2.link + '/' + catlevel3.slug}
            breadcrumbs.push(level3)
          }
        }
      }
      this.breadcrumbs = breadcrumbs

    },
    changeSorting(sort) {

      this.sortBy.selected = sort;
      ProductOptions.changeSorting(sort);
    },
    changeItemsPerPage(itemsPerPage) {
      this.pagination.itemsPerPage = itemsPerPage;
      ProductOptions.changeItemsPerPage(itemsPerPage);
    },
    fetchProducts(activeCategory) {
      this.checkActiveCategory(activeCategory)
      if (this.$router.history.current.query.page) {
        this.loadingNext = true;
      } else {
        this.loading = true;
      }

      let content = [];
      this.getChildCategory(activeCategory)


      Api.product.getByCategory(activeCategory.path, this.$router.history.current.query)
          .then(data => {
            if (data?.products) {
              this.pagination = Pagination.of(data.products);
              this.totalPages = data.products.totalPages;
              this.pagination = Pagination.of(data.products);
              this.totalPages = data.products.totalPages;
              this.itemsPerPage = data.products.size;
              this.totalElements = data.products.totalElements;
              this.currentPage = data.products.number + 1;

              for (let lightProduct of data.products.content) {
                content.push(LightProduct.of(lightProduct));
              }
            }
          })
          .catch((e) => {

            if(e.status !==499) {
              console.error(e)
              this.error = e;
              this.$store.dispatch('sendNotification', {
                type: 'danger',
                message: this.$i18n.t('errors.server.access'),
                icon: icons.error
              });
            }
          }).finally(() => {
        if (this.products && this.$router.history.current.query.page) {
          let products = [...this.products, ...content]
          this.products = products
        } else {
          this.products = content;
        }
        if (this.$router.history.current.query.page) {
          this.loadingNext = false;
        } else {
          this.loading = false;
        }

      })
    },
    reloadProduct(activeCategory) {
      this.checkActiveCategory(activeCategory)
      this.loading = true;
      let content = [];
      this.getChildCategory(activeCategory)
      Api.product.getReloadedByCategory(activeCategory.path, this.$router.history.current.query)
          .then(data => {
            if (data?.products) {
              this.pagination = Pagination.of(data.products);
              this.itemsPerPage = data.products.size;
              this.totalElements = data.products.totalElements;
              this.pagination = Pagination.of(data.products);
              this.totalPages = data.products.totalPages;
              for (let lightProduct of data.products.content) {
                content.push(LightProduct.of(lightProduct));
              }
            }
          })
          .catch((e) => {
            if(e.status !==499) {
              console.error(e)
              this.error = e;
              this.$store.dispatch('sendNotification', {
                type: 'danger',
                message: this.$i18n.t('errors.server.access'),
                icon: icons.error
              });
            }
          }).finally(() => {
        if (this.products) {
          let products = [...this.products, ...content]
          this.products = products
        } else {
          this.products = content;
        }
        this.loading = false;

      })
    }
  }
}

</script>

